import { createElement as _createElement } from "preact";
import useSponsoredWikiCardState from '../hooks/useSponsoredWikiCardState';
import SponsoredWikiCard3Column from './SponsoredWikiCard3Column';
export default function SponsoredWikiCard({ verticalType, gridLayout, isForced, isDarkTheme, track, }) {
    const sponsoredContent = useSponsoredWikiCardState({ verticalType, isForced });
    if (!sponsoredContent) {
        return null;
    }
    if (gridLayout === '3-column') {
        return (_createElement(SponsoredWikiCard3Column, Object.assign({}, sponsoredContent, { key: `${verticalType}-${gridLayout}-${sponsoredContent.id}`, track: track, isDarkTheme: isDarkTheme })));
    }
    return null;
}
